import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { emailSignInFormUpdate, emailSignIn } from "actions/email-sign-in";
import LoaderButton from 'components/LoaderButton';
import AlertDialog from 'components/AlertDialog';
import TextField from '@material-ui/core/TextField';
import ActionExitToApp from '@material-ui/icons/ExitToApp';

class EmailSignInForm extends React.Component {
  static propTypes = {
    endpoint: PropTypes.string,
    next: PropTypes.func,
    inputProps: PropTypes.shape({
      email: PropTypes.object,
      password: PropTypes.object,
      submit: PropTypes.object
    })
  };

  static defaultProps = {
    next: () => {},
    inputProps: {
      email: {},
      password: {},
      submit: {}
    }
  };

  getEndpoint () {
    return (
      this.props.endpoint ||
      this.props.auth.getIn(["configure", "currentEndpointKey"]) ||
      this.props.auth.getIn(["configure", "defaultEndpointKey"])
    );
  }

  handleInput (key, event) {
    let val = event.target.value;
    this.props.dispatch(emailSignInFormUpdate(this.getEndpoint(), key, val));
  }

  handleSubmit (event) {
    event.preventDefault();
    let formData = this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "form"]).toJS();
    this.props.dispatch(emailSignIn(formData, this.getEndpoint()))
      .then(this.props.next)
      .catch(() => {});
  }

  errorAlertDialog () {
    let errorWrapper = this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "errors"])
    if(errorWrapper) {
      let errors = errorWrapper.toJS().errors
      if(errors.size != 0) {
        return (
          <AlertDialog
            open={true}
            showButton={false}
            showLeftButton={false}
            buttonLabel='Confirm'
            variant='raised'
            color='primary'
            title='Login failed'
            desc={errors[0]}
          />
          )
      }
    }
  }

  render () {
    let disabled = (
      this.props.auth.getIn(["user", "isSignedIn"]) ||
      this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "loading"])
    );

    return (
      <form className='redux-auth email-sign-in-form'
        style={{clear: "both", overflow: "hidden"}}
        onSubmit={this.handleSubmit.bind(this)}>
        <div className='form-row' >
          <TextField type="text"
            label="Email"
            className="email-sign-in-email"
            ref="emailSignInEmail"
            floatingLabelText="Email"
            disabled={disabled}
            value={this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "form", "email"])}
            errors={this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "errors", "email"])}
            onChange={this.handleInput.bind(this, "email")}
            {...this.props.inputProps.email} />
        </div>

        <div className='form-row' >
          <TextField type="password"
            label="Password"
            floatingLabelText="Password"
            className="email-sign-in-password"
            disabled={disabled}
            value={this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "form", "password"])}
            errors={this.props.auth.getIn(["emailSignIn", this.getEndpoint(), "errors", "password"])}
            onChange={this.handleInput.bind(this, "password")}
            {...this.props.inputProps.password} />
        </div>

        <div className='form-row' >
          <LoaderButton loading={this.props.auth.getIn(["emailSignIn", "loading"])}
            type="submit"
            icon={ActionExitToApp}
            className='email-sign-in-submit'
            disabled={disabled}
            onClick={this.handleSubmit.bind(this)}
            primary={true}
            {...this.props.inputProps.submit}>
            Sign In
          </LoaderButton>
        </div>
        {this.errorAlertDialog()}
      </form>
    );
  }
}

export default connect(({auth}) => ({auth}))(EmailSignInForm);



// WEBPACK FOOTER //
// ./src/components/EmailSignInForm/index.js